import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatYouGet } from './components/WhatYouGet';
import { WhatYouImprove } from './components/WhatYouImprove';
import { Bonuses } from './components/Bonuses';
import { UrgencyPricing } from './components/UrgencyPricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { VerifiedPurchasePopup } from './components/VerifiedPurchasePopup';
export function App() {
  useEffect(() => {
    const PIXEL_ID = '1904779843432668';
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-vbred selection:text-white" data-id="element-0" data-mp="2zng0qi58cgrv">
      <Hero data-id="element-1" data-mp="38lrnua6w0wfk" />
      <PainPoints data-id="element-2" data-mp="38m1f013o59mu" />
      <WhatYouGet data-id="element-3" data-mp="38li6fazwrxlh" />
      <WhatYouImprove data-id="element-4" data-mp="38l00tnrcw70w" />
      <Bonuses data-id="element-5" data-mp="38nuqbtp88i16" />
      <UrgencyPricing data-id="element-6" data-mp="3dkuufz2inapn" />
      <Testimonials data-id="element-7" data-mp="3dle3sre3oqs2" />
      <FAQ data-id="element-8" data-mp="3dlntedv8gvx8" />
      <FinalCTA data-id="element-9" data-mp="3dmfolnkx4rmz" />
      <Footer data-id="element-10" data-mp="3dirtwl3qlz6o" />
      <VerifiedPurchasePopup data-id="element-11" data-mp="nvj4bi5joiqs" />
    </div>;
}